import { FAMILY_NAME_GIVEN_NAME_ORDERING_INDEXED_BY_LANGUAGE } from './constants.mjs';
import { nonEmptyOrUndefined } from './utilities/nonEmptyOrUndefined.mjs';
import { languageFromLocale } from './utilities/languageFromLocale.mjs';

// Note: A similar Ruby implementation of this function also exists at https://github.com/Shopify/shopify-i18n/blob/main/lib/shopify-i18n/name_formatter.rb.
function formatName({
  name,
  locale,
  options
}) {
  const givenName = nonEmptyOrUndefined(name === null || name === void 0 ? void 0 : name.givenName);
  const familyName = nonEmptyOrUndefined(name === null || name === void 0 ? void 0 : name.familyName);
  if (familyName && !givenName) {
    return familyName;
  }
  if (givenName && !familyName) {
    return givenName;
  }
  if (givenName && familyName) {
    const isFullName = Boolean(options && options.full);
    const customNameFormatter = FAMILY_NAME_GIVEN_NAME_ORDERING_INDEXED_BY_LANGUAGE.get(languageFromLocale(locale));
    if (customNameFormatter) {
      return customNameFormatter(givenName, familyName, isFullName);
    }
    if (isFullName) {
      return `${givenName} ${familyName}`;
    }
  }
  return givenName;
}

export { formatName };
